import { reactive } from "vue";

// Booking uses a separate explicit per-call mechanism instead (see axios.ts).
export const delegationContext = reactive<{
  targetTenantId?: string;
  targetTenantUrl?: string;
  targetTenantName?: string;
  homeTenantId?: string;
  trigger?: string;
}>({});

export function setDelegationContext(context: {
  targetTenantId?: string;
  targetTenantUrl?: string;
  targetTenantName?: string;
  homeTenantId?: string;
  trigger?: string;
}) {
  delegationContext.targetTenantId = context.targetTenantId;
  delegationContext.targetTenantUrl = context.targetTenantUrl;
  delegationContext.targetTenantName = context.targetTenantName;
  delegationContext.homeTenantId = context.homeTenantId;
  delegationContext.trigger = context.trigger;
}

export function clearDelegationContext() {
  delegationContext.targetTenantId = undefined;
  delegationContext.targetTenantUrl = undefined;
  delegationContext.targetTenantName = undefined;
  delegationContext.homeTenantId = undefined;
  delegationContext.trigger = undefined;
}

const STORE_KEY = "delegation-current-page-tenant";

// sessionStorage has no expiry and clinical desktops leave tabs open for days. A stale tenant
// routes writes, not just reads.
const MAX_AGE_MILLISECONDS = 45 * 60 * 1000;

type StoredPageTenant = { tenantId: string; setAt: number };

export function setCurrentPageTenant(tenantId: string) {
  const stored: StoredPageTenant = { tenantId, setAt: Date.now() };
  sessionStorage.setItem(STORE_KEY, JSON.stringify(stored));
}

export function currentPageTenant(): string | undefined {
  const raw = sessionStorage.getItem(STORE_KEY);
  if (!raw) return undefined;

  let stored: StoredPageTenant;
  try {
    stored = JSON.parse(raw);
  } catch {
    sessionStorage.removeItem(STORE_KEY);
    return undefined;
  }

  if (!stored?.tenantId || Date.now() - stored.setAt > MAX_AGE_MILLISECONDS) {
    sessionStorage.removeItem(STORE_KEY);
    return undefined;
  }

  return stored.tenantId;
}

export function clearCurrentPageTenant() {
  sessionStorage.removeItem(STORE_KEY);
}
